import { FormValidator, ValidationRules } from 'src/utils/FormValidator';
import { ERROR_MESSAGES, VALIDATION_PATTERNS } from 'src/contstant/commonLabels';

/**
 * Coerces a form value to a numeric task-duration-days value.
 * Returns null for anything that is not a positive whole-day integer.
 */
const toDurationNumber = (value: unknown): number | null => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num) || !Number.isInteger(num)) {
    return null;
  }
  return num;
};

export const TaskValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator.addRule('taskName', ValidationRules.required, 'Error: Task name is required');

  // Task duration must be explicitly provided by the operator: no silent
  // fallbacks. Required check runs first so an empty value surfaces the
  // right message; the range check follows only when a value is present.
  validator.addRule(
    'taskDurationDays',
    (value: unknown) => value !== null && value !== undefined && value !== '',
    'Error: Task duration is required',
  );
  validator.addRule(
    'taskDurationDays',
    (value: unknown) => {
      const num = toDurationNumber(value);
      return num !== null && num >= 1 && num <= 365;
    },
    'Error: Task duration must be a whole number between 1 and 365 days',
  );

  validator.addRule(
    'taskDescription',
    ValidationRules.required,
    'Error: Task description is required',
  );
  validator.addRule('assignee', ValidationRules.required, 'Error: Assignee is required');
  validator.addRule(
    'assignee',
    (value: string) => VALIDATION_PATTERNS.ASSIGNEE_ALIAS.test(value),
    `Error: ${ERROR_MESSAGES.ASSIGNEE_AT_SYMBOL}`,
  );

  return validator;
};
